import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import ResourcesLeft from '../Resources/Resources_Left'

function Main() {


    const ImageData1 = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/6.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/1.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/2.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/3.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/4.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/5.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/7.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/8.jpg" },

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/10.jpg" }
      

    ]


    const ImageData2 = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/InterIITSportsMeet/9.jpg" }

     
    ]

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Inter-IIT-Sports-Meet" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>
                   

                            <Col md={12} className='c-right c-lineheight2dot5 text-dark'>
                                <h3 className='c-headline mb-3'>52nd Inter-IIT Sports Meet, Dec 16 – 23, 2017</h3>
                                <p>Students from IIT Tirupati participated in the 52nd Inter-IIT Sports Meet at IIT Madras from December 16 – 23, 2017. A number of students produced many fine performances in the event and distinguished themselves. Notable among them was Sanugula Spandana (1st Civil Engineering) who finished fourth in the women’s high jump event with a jump of 1.25 m. The cricket team emerged victorious against IIT Dharwad and marched on to the Pre-quarterfinals, before bowing out against a strong IIT Kanpur team. The opportunity offered by the Pan-IIT event to compete and interact with students from all over India was relished by our students. Although there were no medals to show for their efforts, our students returned in high spirits and with a greater determination to prove their mettle in future Inter-IIT events. </p>

                         
                                <h3 className='c-headline mt-5 mb-3'>Our Gallery</h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {ImageData1.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>                        
                                                <figure className="gallery-image">
                                                    <img src={item.img} alt="img" className="img" />
                                                </figure>
                                        </div>
                                    ))}
                                </div>


                                <h3 className='c-headline mt-5 mb-3'>24th Inter-IIT Staff Sports Meet, Dec. 26 – 30, 2017</h3>
                                <p>Faculty and Staff members from IIT Tirupati participated in the 24th Inter-IIT Staff Sports Meet at IIT Madras from December 26 – 30, 2017. This was the first time that IIT Tirupati was making its presence felt at this event. There were a number of excellent performances from our staff members – Mr. Chandra Siva Kumar (Badminton), Mr. Senthamilselvan (Cricket), Dr. Shihabudheen Maliyekkal (Athletics), and Mr. Singareddy Anjaneyulu (Athletics). </p>

                                <h3 className='c-headline mt-5 mb-3'>Our Gallery</h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {ImageData2.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            <figure className="gallery-image">
                                                <img src={item.img} alt="img" className="img" />
                                            </figure>
                                        </div>
                                    ))}
                                </div>

                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;